import { useMapContext } from '../../map/MapContext';
import type { LayerFeature } from '../../lib/layersApi';
import { LayerTable } from './LayerTable';

function pickTitle(feature: LayerFeature): string {
  const firstString = Object.values(feature.properties).find((v): v is string => typeof v === 'string' && v.length > 0);
  return firstString ?? 'Объект';
}

export function LayerTableSheet() {
  const { openTableLayer, closeLayerTable, flyToSearchHit } = useMapContext();

  if (!openTableLayer) return null;

  const handleGoToObject = (feature: LayerFeature) => {
    if (!feature.geometry) return;
    flyToSearchHit(feature.geometry, {
      name: pickTitle(feature),
      objectType: openTableLayer.name,
      ...feature.properties,
    });
  };

  return (
    <div className="absolute inset-x-6 bottom-6 z-20 flex h-[42vh] flex-col overflow-hidden rounded-2xl border border-border-default bg-bg-surface shadow-2xl">
      <div className="flex shrink-0 items-center gap-3 border-b border-border-default px-4 py-3">
        <h3 className="flex-1 truncate text-sm font-semibold text-text-primary">Таблица · {openTableLayer.name}</h3>
        <button
          type="button"
          onClick={closeLayerTable}
          title="Закрыть"
          className="flex size-8 items-center justify-center rounded-lg text-text-secondary hover:bg-bg-surface-secondary"
        >
          ✕
        </button>
      </div>
      <div className="flex-1 overflow-hidden">
        <LayerTable layerId={openTableLayer.id} onGoToObject={handleGoToObject} />
      </div>
    </div>
  );
}
